<template>
  <div class="Tetapkanpenyeliaprosesanoperasi">
    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <v-breadcrumbs-item
        slot="items"
        slot-scope="{ items }"
        exact
        :to="items.to"
        :disabled="items.disabled"
      >
        {{ items.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("tetapkanpppo") }}
      </v-card-title>
      <v-container>
        <Pppoinput></Pppoinput>
      </v-container>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Pppoinput from "@/components/Pppoinput/pppoinput";
export default {
  name: "Tetapkanpenyeliaprosesanoperasi",
  components: {
    Pppoinput,
  },
  setup() {},
  mounted() {},
  data: () => ({
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: "paparanutama",
      },
      {
        text: i18n.t("tetapkanpppo"),
        disabled: true,
        href: "",
      },
    ],
  }),
  methods: {},
};
</script>